import { animated } from '@react-spring/web';
import styled, { css } from 'styled-components';
import {
  spacings,
  shadows,
  popeyesSecondaryColors,
  font,
  breakpoints,
  popeyesNeutral,
  transitions,
} from 'styles';
import sizes from 'utils/screenSizes';

import * as T from './interfaces';

export const SearchInputWrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const OptionsWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  button {
    transition: ${transitions.color01};
    font-weight: bold;
    font-family: ${font.family.ChickenHeadline};
  }
`;

export const Limiter = styled.div`
  width: 100%;
  background: #f2f2f2;
`;

const WrapperModifier = {
  session: {
    nearStores: () => css`
      ${OptionsWrapper} {
        button {
          :last-child {
            color: ${popeyesSecondaryColors.dark};
          }

          :first-child {
            color: ${popeyesNeutral.neutral06};
          }
        }
      }
    `,
    favoriteStores: () => css`
      ${OptionsWrapper} {
        button {
          :last-child {
            color: ${popeyesNeutral.neutral06};
          }

          :first-child {
            color: ${popeyesSecondaryColors.dark};
          }
        }
      }
    `,
  },
  mode: {
    list: () => css`
      button {
        &.search {
          img {
            width: 30px;
          }
        }
      }
    `,
    map: () => css`
      button {
        &.search {
          img {
            width: 15px;

            margin: 0 auto;
          }
        }
      }
    `,
  },
  height: (height: number) => {
    if (height < 199) {
      return css`
        ${SearchInputWrapper} {
          transition: ${transitions.opacity01};
          opacity: 0;
          input,
          button {
            pointer-events: none;
          }
        }
        ${OptionsWrapper} {
          transition: ${transitions.all01};
          opacity: ${height > 199 ? 1 : 0};
        }
      `;
    }
  },
};

const MediaModifier = {
  desktop: () => css`
    button {
      &.arrow {
        top: 20px;
        left: 20px;
        ::after {
          content: 'Voltar';
          position: absolute;
          transform: translate(70%, -150%);
          font-size: ${font.sizes.textMedium};
          font-family: ${font.family.ChickenText};
        }
      }
    }

    ${OptionsWrapper} {
      button {
        font-size: ${font.sizes.heading04};
      }
    }
  `,
  mobile: () => css`
    button {
      &.arrow {
        top: 15px;
        left: 10px;

        img {
          transform: rotate(-90deg) scale(0.6);
        }
      }
    }

    ${OptionsWrapper} {
      button {
        font-size: ${font.sizes.heading05};
      }
    }
  `,
};

export const SearchHeader = styled(animated.div)<T.IHeaderSearchStyles>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  width: 100%;
  height: 100%;
  top: 0;
  padding: ${spacings.space05} ${spacings.space05} ${spacings.space06};
  background-color: ${popeyesSecondaryColors.light};
  box-shadow: ${shadows.shadow04};
  transition: ${transitions.all01};
  button {
    &.search {
      width: 60px;
      height: 52px;
      margin-left: ${spacings.space04};
    }

    &.arrow {
      margin-right: auto;
    }
  }

  h6 {
    font-family: ${font.family.ChickenText};
    font-size: ${font.sizes.textMedium};
  }

  @media (min-width: ${breakpoints.intermediary}) {
    ${MediaModifier.desktop()}
    position: relative;
  }

  @media (max-width: ${breakpoints.intermediary}) {
    ${MediaModifier.mobile()}
    position: fixed;
  }

  ${({ session, mode, height }) => css`
    ${WrapperModifier.session[session]()}
    ${WrapperModifier.mode[mode]()}
    ${WrapperModifier.height(height)}
  `}
`;

export const HeadingWrapper = styled.div`
  margin-top: 7px;
  position: relative;
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

export const BackButton = styled.div`
  position: absolute;
  left: 0;

  width: 91px;
  margin: 0 0 0 4%;

  z-index: 3;
  :hover {
    cursor: pointer;
  }

  display: flex;
  align-items: flex-end;
  img {
    height: 1.5rem;
    width: auto;
    margin: 0 14% 0 0;
  }
  p {
    font-size: 1.5rem;
    color: var(--color-popeyes-orange);
  }
`;

export const BackButtonIcon = styled.div`

@media all and (max-width: ${sizes.notebook}) {
  position: absolute;
  left: 0;

  width: 26px;
  margin: 7px 0 0 5%;


  z-index: 3;
  :hover {
    cursor: pointer;
  }

  img {
    height: 1.125rem;
    width: auto;
    margin: 0 14% 0 0;
    transform: rotate(270deg);
}

`;
